import { addIndex, isNil, map } from 'ramda';
import React, { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { concat } from '../../common/helpers/arrayHelper';
import { IReferenceCandidateForm } from '../../common/models/reference/IReferenceCandidateForm';
import { IRefReqCounters } from '../../common/models/referenceRequest/IRefReqCounters';
import Icon from '../Icon';
import { RefFormPages } from '../../scenes/CandidateForm/containers/CandidateForm/utils';
import { messages } from '../../scenes/CandidateForm/containers/ReferenceCard/utils';
import { getReferenceProgress } from '../../scenes/CandidateForm/containers/ReferenceForm/utils';
import ProgressBar from '../../scenes/CandidateForm/components/ProgressBar';
import styles from './styles.module.scss';

interface IProps {
  currentPage: RefFormPages;
  references: IReferenceCandidateForm[];
  refCounters: IRefReqCounters;
  currentReference: IReferenceCandidateForm;
}

const RefFormSidebar: FunctionComponent<IProps> = ({
  currentPage,
  references,
  refCounters,
  currentReference
}) => {
  const leftCount = refCounters.totalCount <= references.length ? 0 : refCounters.totalCount - references.length - 1;

  const Reference: FunctionComponent<{
    reference: IReferenceCandidateForm;
    index: number;
    currentRefIndex?: number;
  }> = ({ reference, index, currentRefIndex }) => {
    const progress = getReferenceProgress(reference);
    return (
      <FormattedMessage id="reference" defaultMessage="Reference">
        {mes => (
          <div
            className={concat(styles.item,
              (!isNil(currentRefIndex) && currentRefIndex === index) && styles.finish)}
          >
            <div className={styles.icon}>
              {progress === 1
                ? <span className="check-circle"><Icon icon="check" /></span>
                : <ProgressBar value={progress} max={1} className="cf-progress" />}
            </div>
            <div className="d-flex flex-column">
              {`${mes} ${index + 1}`}
              {progress === 1
                ? (
                  <div className={styles.user}>
                    {reference.type
                      ? (
                        <FormattedMessage {...messages[reference.type]}>
                          {role => `${reference.firstName} ${reference.lastName}, ${role}`}
                        </FormattedMessage>
                      )
                      : `${reference.firstName} ${reference.lastName}`}
                  </div>
                )
                : ''}
            </div>
          </div>
        )}
      </FormattedMessage>
    );
  };

  return (
    <>
      <p className={styles.title}>
        <FormattedMessage id="positionTable.progress" defaultMessage="Progress" />
      </p>
      <div className={`${styles.item} ${currentPage === RefFormPages.Overview ? styles.finish : ''}`}>
        <span className={`${styles.icon} check-circle`}><Icon icon="check" /></span>
        <FormattedMessage id="candidateForm.consent.header" defaultMessage="Consent form" />
      </div>
      {addIndex(map)((r, index) => (
        <Reference
          currentRefIndex={currentPage !== RefFormPages.Overview ? references.length : undefined}
          key={`reference ${index}`}
          reference={r as IReferenceCandidateForm}
          index={index}
        />
      ), [...references, currentReference, ...new Array(leftCount)])}
    </>
  );
};

export default RefFormSidebar;
